import femaleNoImage from "../Assets/femalenoimage.png";
import maleNoImage from "../Assets/mennoimage.png";

export function getProfilePlaceholderImage(gender) {
  return gender === "Female" ? femaleNoImage : maleNoImage;
}

export function shouldShowProfilePlaceholder(profile) {
  return Boolean(profile?.hidePhotos || !profile?.imageUrls?.[0]);
}

export function getProfileDisplayImage(profile) {
  if (shouldShowProfilePlaceholder(profile)) {
    return getProfilePlaceholderImage(profile?.gender);
  }
  return profile?.imageUrls?.[0] || null;
}
